import { render, staticRenderFns } from "./abnormalPackageMark.vue?vue&type=template&id=3f459dbc&scoped=true"
import script from "./abnormalPackageMark.vue?vue&type=script&lang=js"
export * from "./abnormalPackageMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f459dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f459dbc')) {
      api.createRecord('3f459dbc', component.options)
    } else {
      api.reload('3f459dbc', component.options)
    }
    module.hot.accept("./abnormalPackageMark.vue?vue&type=template&id=3f459dbc&scoped=true", function () {
      api.rerender('3f459dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/abnormalPackageMark.vue"
export default component.exports